export const MAIN_CORE_DISPLAY_MODE_KEY = 'mainCoreDisplayMode';
export const MAIN_CORE_DISPLAY_MODE_EVENT = 'q:main-core-display-mode-changed';

export function normalizeMainCoreDisplayMode(mode) {
  return mode === 'buttons' ? 'buttons' : 'sphere';
}

export function getMainCoreDisplayMode() {
  try {
    return normalizeMainCoreDisplayMode(localStorage.getItem(MAIN_CORE_DISPLAY_MODE_KEY));
  } catch (_) {
    return 'sphere';
  }
}

export function setMainCoreDisplayMode(mode) {
  const normalized = normalizeMainCoreDisplayMode(mode);
  try {
    localStorage.setItem(MAIN_CORE_DISPLAY_MODE_KEY, normalized);
  } catch (_) {}

  try {
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
      window.dispatchEvent(new Event(MAIN_CORE_DISPLAY_MODE_EVENT));
    }
  } catch (_) {}

  return normalized;
}
